import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { push } from "connected-react-router";
import classnames from 'classnames';

import ClientMini from "./ClientMini/ClientMini";
import PaginationBlock from "../../ui/PaginationBlock/PaginationBlock";
import Arrows from "../../ui/Arrows/Arrows";
import Spinner from "../../ui/Spinner/Spinner";
import RequireAuth from "../../layout/HOC/require-auth";

import './ConsultantInfo.scss';
import Ava from "./avaBig.svg";

import { getConsultantInfoAsync } from "../../../redux/actions/consultantInfo";
import { formatPhone } from "../../../methods";

import {
  changeConsultantClientsPage,
  changeConsultantClientsLimit,
  getConsultantClientsListAsync,
  changeConsultantClientsSorting,
} from "../../../redux/actions/consultantClientsList";

const mapStateToProps = state => ({
  ...state.consultantInfo,
  ...state.consultantClientsList, 
});

const mapDispatchToProps = dispatch => ({
  onChangePage: page => dispatch(changeConsultantClientsPage(page)),
  onChangeDisplayOption: limit => dispatch(changeConsultantClientsLimit(limit)),
  getConsultantClients: payload => dispatch(getConsultantClientsListAsync(payload)),
  getConsultantInfo: id => dispatch(getConsultantInfoAsync(id)),
  onGoBack: () => dispatch(push('/consultants')),
  changeSorting: (sort, order) => dispatch(changeConsultantClientsSorting(sort, order)),
});

class ConsultantInfo extends Component {
  static propTypes = {
    ready: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    cons_ready: PropTypes.bool.isRequired,
    cons_loading: PropTypes.bool.isRequired,
    clients: PropTypes.array.isRequired,
    total: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    activePage: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    onChangeDisplayOption: PropTypes.func.isRequired,
    getConsultantClients: PropTypes.func.isRequired,
    consultant: PropTypes.object.isRequired,
    onGoBack: PropTypes.func.isRequired,
    getConsultantInfo: PropTypes.func.isRequired,
    //Сортировка
    changeSorting: PropTypes.func.isRequired,
    sorting: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { getConsultantClients, getConsultantInfo } = this.props;
    const id = this.props.match.params.id;
    const payload = this.setPayload();

    getConsultantClients(payload);
    getConsultantInfo(id);
  }

  //Пагинация и фильтры
  componentDidUpdate = previousProps => {
    const { limit, activePage, sorting, getConsultantClients } = this.props;
    const payload = this.setPayload();

    //Условия перезагрузки
    if (
      (previousProps.activePage !== activePage)
      || (previousProps.limit !== limit)
      || ((previousProps.sorting.sort !== sorting.sort))
      || ((previousProps.sorting.order !== sorting.order)) 
    ) getConsultantClients(payload);
  }

  setPayload = () => {
    const { limit, activePage, sorting } = this.props;
    const id = this.props.match.params.id;
    //Клиенты консультанта
    const payload = { 
      limit,
      page: activePage,
      consultant_id: id,
      sort: sorting.sort,
      order: Number(sorting.order),
    };
    return payload;
  }

  //СОРТИРОВКА
  onChangeSorting = sortOption => {
    const { sorting, changeSorting } = this.props;
    let order = true;
    if (sorting.sort === sortOption) order = !sorting.order;
    changeSorting(sortOption, order);
  }

  renderClientsList = (item, i) => {
    return(
      <ClientMini key={`${item.id}_${i}`} client={item} />
    );
  }

  render() {
    const {
      ready, cons_ready, loading, cons_loading, sorting, consultant, onGoBack,
      clients, limit, total, activePage, onChangePage, onChangeDisplayOption,
    } = this.props;

    const src = consultant.avatar && consultant.avatar.url ? consultant.avatar.url : Ava;
    //Рассчитаем количество страниц пагинации
    const pagesCount = Math.ceil(total / limit);

  //Классы для сортировки
  const nameClass = classnames({
    'header-item': true,
    'name': true,
    'current': sorting.sort === 'last_name',
  });

  const phoneClass = classnames({
    'header-item': true,
    'phone': true,
    'current': sorting.sort === 'phone',
  });

  const emailClass = classnames({
    'header-item': true,
    'email': true,
    'current': sorting.sort === 'email',
  });

  const dateClass = classnames({
    'header-item': true,
    'date': true,
    'current': sorting.sort === 'created_at',
  });

  const contentClass = classnames({
    'page-content': true,
    'consultant': true,
    'blocked': consultant.status === 'DISABLED',
  });

    return (
      <div className="page-wrapper">

        {(consultant.status === 'DISABLED') ? (
          <div className="cons-bloced"><div className="icon" />Заблокирован</div>
        ) : false}
        {cons_ready ? (
          <React.Fragment>
            <div className="page-header">
              <button type="button" className="btn btn-back" onClick={() => onGoBack()}>
                <i aria-hidden="true" className="back-icon icon" />
                <span>Назад</span> 
              </button>
            </div>
            <div className={contentClass}>
              <div className="cons-info-header">
                <div className="ava-wrap">
                  <img src={src} alt="" />
                </div>
                <div className="info-wrap">
                  <div className="info-name">{consultant.name} {consultant.surname}</div>
                  <div className="info-id">ID {consultant.external_id}</div>
                  <div className="info-row phone">
                    <div className="phone" />
                    <a href={`tel:${consultant.phone}`}>{formatPhone(consultant.phone)}</a>
                  </div>
                  <div className="info-row email">
                    <div className="email" />
                    <a href={`mailto:${consultant.email}`}>{consultant.email}</a>
                  </div>
                  {/*
                  <div className="info-row grade"><div className="grade" />Global expansion team</div>
                  */}
                </div>
              </div>
              {/* Список клиентов и пагинация */}
              <div className="lists-content mini">
                <div className="content-title">
                  Клиенты: { total }
                </div>
                {ready ? (
                  <React.Fragment>
                    <div className="list-header">
                      <button
                          type="button"
                          className={nameClass}
                          onClick={() => this.onChangeSorting('last_name')}
                      >
                        Имя
                        <Arrows
                          sortUp={(sorting.sort === 'last_name') && (sorting.order)}
                          sortDown={(sorting.sort === 'last_name') && (!sorting.order)}
                        />
                      </button>
                      <button
                        type="button"
                        className={phoneClass}
                        onClick={() => this.onChangeSorting('phone')}
                      >
                        Номер телефона
                        <Arrows
                          sortUp={(sorting.sort === 'phone') && (sorting.order)}
                          sortDown={(sorting.sort === 'phone') && (!sorting.order)}
                        />
                      </button>
                      <button
                        type="button"
                        className={emailClass}
                        onClick={() => this.onChangeSorting('email')}
                      >
                        E-mail
                        <Arrows
                          sortUp={(sorting.sort === 'email') && (sorting.order)} 
                          sortDown={(sorting.sort === 'email') && (!sorting.order)}
                        />
                      </button>
                      <div className="header-item address">Адрес</div>
                      <button
                        type="button"
                        className={dateClass}
                        onClick={() => this.onChangeSorting('created_at')}
                      >
                        <div>Дата</div> 
                        <div className="div-wrap">
                          регистрации
                          <Arrows
                            sortUp={(sorting.sort === 'created_at') && (sorting.order)}
                            sortDown={(sorting.sort === 'created_at') && (!sorting.order)}
                          />
                        </div>
                      </button>
                      <div className="header-item consult-id">Консультант</div>
                    </div>
                    {clients.length !== 0 ? clients.map(this.renderClientsList) : false}
                  </React.Fragment>
                ) : false}
                {loading ? (<Spinner />) : false}
              </div>
              <div className="c-info-footer">
                {clients.length !== 0 ? (
                  <PaginationBlock
                    bordered
                    activePage={activePage}
                    pagesCount={pagesCount}
                    pagesVisible={7}
                    onChangePage={onChangePage}
                    displayOptions={[15, 30, 60, 120]}
                    selectedDisplayOption={limit}
                    selectDisplayOption={onChangeDisplayOption}
                  />
                ) : false}
              </div>
            </div>
          </React.Fragment>
        ) : false}
        {cons_loading ? (<Spinner />) : false}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequireAuth(ConsultantInfo));
